export default [
    {
        path: '/search',
        name: 'search-results',
        component: () => import('@/pages/search/SearchResults.vue'),
        meta: {
            title: 'Search Results',
        },
        props: route => ({
            query: route.query.query,
            type: route.query.type || null,
            types: route.query.types || null,
            page: parseInt(route.query.page, 10) || 1,
            sort: route.query.sort || null,
            sortDirection: route.query.sort_direction || null,
        }),
    },
];
